import { OnInit, Optional, Inject, Component } from '@angular/core';
import { PershingTranslationService } from '@pershing/pershing-core';
import { BalancesService } from '../../services/balances.services';
import { Mortgages, Loans } from '../../model';
import { MatButtonToggleChange } from '@angular/material/button-toggle';

@Component({
    selector: 'balance-details-container',
    templateUrl: './balance-details-container.component.html'
})
export class BalanceDetailsContainerComponent implements OnInit {

    mortgagesData: Mortgages;
    loansData: Loans;
    toggle: boolean = true;
    displayContainer: any;
    data: any
    displayToggle: boolean;
    mobiletoggle: any;
    isLoading: boolean = true;
    constructor(
        private translationService: PershingTranslationService,
        private balancesService: BalancesService,
        @Optional() @Inject('AppSettings') appSettings: any
    ) {
    }

    ngOnInit() {
        this.translationService.addTranslationFolder('@pershing/nxi-ng-balances', 'node_modules/@pershing/nxi-ng-balances/lib');
        this.displayToggle = true;
        this.getUserLiabilities();
    }

    getUserLiabilities() {
        this.balancesService.getLiabilities().subscribe(resp => {
            this.data = resp;
            if (!!this.data) {
                this.mortgagesData = this.data.mortgages;
                this.loansData = this.data.loans;
                if (this.mortgagesData === null && this.loansData === null) {
                    this.displayToggle = true;
                } else {
                    this.displayToggle = false;
                    this.displayContainer = 'investments';
                }
                if(!this.displayToggle && this.displayContainer === "loans"){
                    this.balancesService.setShowCurrencyDetails(false);
                }else{
                    this.balancesService.setShowCurrencyDetails(true);
                }
            }
            this.isLoading = false;
        });
    }
    toggleView(change: MatButtonToggleChange) {
        this.toggle = change.value;
        if (!!this.toggle) {
            this.displayContainer = 'investments';
            this.balancesService.setDisplayToggle(true);
        } else {
            this.displayContainer = 'loans';
            this.balancesService.setDisplayToggle(false);
        }
    }
    mobileToggle(value) {
        this.mobiletoggle = value;
        if (this.mobiletoggle === 'investments') {
            this.displayContainer = 'investments';
        } else if (this.mobiletoggle === 'loans') {
            this.displayContainer = 'loans';
        }
    }
}
